import { useState } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { forgotPassword } from '../services/api';

export default function ForgotPasswordPage() {
  const [identifier, setIdentifier] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await forgotPassword({ identifier });
      toast.success(res.data.message || 'Recovery instructions sent if the account exists');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Unable to send recovery instructions');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-yamass-cream flex items-center justify-center px-4 py-12">
      <div className="bg-white rounded-3xl shadow-sm p-10 w-full max-w-md">
        <h1 className="font-display text-3xl font-bold text-yamass-black mb-2">Reset password</h1>
        <p className="text-gray-400 text-sm mb-8">Enter your email address and we&apos;ll send you a password reset link.</p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="text-xs text-gray-500 uppercase tracking-wider block mb-1">Email</label>
            <input
              type="email"
              required
              value={identifier}
              onChange={e => setIdentifier(e.target.value)}
              placeholder="name@example.com"
              className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-yamass-accent"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-yamass-black text-white py-4 rounded-full text-sm font-semibold hover:bg-yamass-accent transition-colors disabled:opacity-50 mt-2"
          >
            {loading ? 'Sending instructions...' : 'Send email link'}
          </button>
        </form>
        <p className="text-center text-sm text-gray-400 mt-6">
          Remembered it? <Link to="/login" className="text-yamass-accent font-medium hover:underline">Back to login</Link>
        </p>
      </div>
    </div>
  );
}
